import React from 'react';
import axios from 'axios';
import ImageAnswerUpload from './imageAnswerUpload.component';

class Assets extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            images: []
        }
    }

    componentDidMount() {
        const headers = {
            'X-Access-Token': this.props.userdata.accessToken
        }

        axios.get(this.props.apiurl + '/api/images/gallery', { headers: headers }).then(res => {
            console.log(res);
            let gallery = []; 

            res.data.gallery.map((image) => {
                gallery.push(
                    {
                        url: this.props.apiurl + '/assets/' + this.props.userdata.userId + "/" + image,
                        name: image
                    }
                )
            });
            this.setState({
                images: gallery
            })
        }).catch(err => {
            console.log(err);
        })
    }

    handleSetImages = (images) => {
        this.setState({
            images: images
        })
    }

    handleDeleteImage = (image) => {
        console.log(image); 
        const headers = {
            'X-Access-Token': this.props.userdata.accessToken
        }
 
        axios.post(this.props.apiurl + '/api/images/delete', { 
            image: image.name
        },{ 
            headers: headers 
        }).then(res => {
            let gallery = []; 
            res.data.gallery.map((image) => {
                gallery.push(
                    {
                        url: this.props.apiurl + '/assets/' + this.props.userdata.userId + "/" + image,
                        name: image
                    }
                )
            });
            this.handleSetImages(gallery); 
        }).catch(err => {
            console.log(err);
        }); 
    }

    render() {

        const imgStyle = { 
            width: 'auto',
            height: '18vh',
            objectFit: 'contain'
        }

        let gallery = []; 
        this.state.images.map((image, index) => {
            gallery.push(
                <div key={index} className="card m-2">
                    <img src={image.url} className="card-img-top" alt="..." style={imgStyle} />
                    <div className="card-body">
                        <p className="card-text">{image.name}</p>
                        <button className="btn btn-outline-danger" onClick={ () => this.handleDeleteImage(image) }>Remove</button>
                    </div>
                </div>
            )
        })


        return (
            <div>
                <ImageAnswerUpload 
                    userdata={ this.props.userdata } 
                    apiurl={ this.props.apiurl }
                    setImages={this.handleSetImages} ></ImageAnswerUpload>
                <div className="row">
                    {gallery}
                </div>
            </div>
        )
    }
}

export default Assets;